import { render, staticRenderFns } from "./StoresView.vue?vue&type=template&id=4a169a6f&scoped=true"
import script from "./StoresView.vue?vue&type=script&lang=js"
export * from "./StoresView.vue?vue&type=script&lang=js"
import style0 from "./StoresView.vue?vue&type=style&index=0&id=4a169a6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a169a6f",
  null
  
)

export default component.exports